<template>
  <el-table v-if="settingType=='CHECK'" stripe border style="width: 100%" height="100%" size="mini"
      :data="tableData" @sort-change="sortChange"
    >
      <el-table-column type="index" align="center"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column width="140px" 
        label="SN" align="center" prop="sn" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.sn }}
          </span>
        </template>
      </el-table-column>
      <el-table-column max-width="110px" 
        label="无线Mac" prop="wlanMac" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.wlanMac">
              {{ scope.row.wlanMac }}
            </span>
            <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column min-width="110px" 
        label="有线Mac" prop="ethMac" align="center" show-overflow-tooltip 
      >
        <template slot-scope="scope">
          <span v-if="scope.row.ethMac">
            {{ scope.row.ethMac }} PCS
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="110px" 
        label="UUID" prop="uuid" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.uuid">
            {{ scope.row.uuid }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="110px" 
        label="IMEI" prop="imei" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.imei">
            {{ scope.row.imei }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="110px" 
        label="组装单号" prop="productionOrderNumber" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.productionOrderNumber">
            {{ scope.row.productionOrderNumber }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="110px" 
        label="包装单号" prop="cartonOrderNumber" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.cartonOrderNumber">
            {{ scope.row.cartonOrderNumber }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="80px" 
        label="内箱" prop="innerCtnIndex" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.innerCtnIndex">
            {{ scope.row.innerCtnIndex }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="80px" 
        label="外箱" prop="outerCtnIndex" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.outerCtnIndex">
            {{ scope.row.outerCtnIndex }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="110px" 
        label="客户" prop="customerName" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.customerName">
            {{ scope.row.customerName }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="责任人" prop="name" align="center" show-overflow-tooltip
        width="100px"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.createUser">
            {{ scope.row.createUser.name }}({{ scope.row.createUser.employeeNum }})
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="验货时间" prop="createDate" align="center" show-overflow-tooltip
        width="120px"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.createDate">
            {{ scope.row.createDate }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
    </el-table>
</template>

<script>

import {
  apiCustomerCheckRecordSearch
} from "@/api/customerCheckRecord.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    settingType:null,
    searchCheckForm:{type: Object},
    pagination:{},
    tabPaneList: {},
  },

  components: {
  },
  
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData:null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {

    // 表格数据
    async getCustomerCheckRecordSearch(remove) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiCustomerCheckRecordSearch({
        ...this.searchCheckForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        
      }
    },
   
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getCustomerCheckRecordSearch();
    },    
  },
};
</script>
<style lang="less" scoped>
.none_border {width:265px; margin: left 2px;; display: -moz-inline-box; display: inline-block;}

  .fail {
    color: #f56c6c;
  }
  .tiaojian {
    color: #e6a23c;
  }
  .pass_{
    color:#67C23A;
  }
</style>